import React from 'react'
import styled from 'styled-components'
import { useMediaQuery } from 'react-responsive'
import Imgix from 'react-imgix'
import { RichText } from 'prismic-reactjs'
import { Link } from 'gatsby'
import tw from 'twin.macro'
import LazyImage, { setPlaceholderImage } from '../LazyImage'

import { linkResolver } from '../../utils/linkResolver'

const ImageLink = ({ slice }) => {
  const isBiggerScreen = useMediaQuery({
    query: '(min-width: 640px)'
  })

  const doc = slice.primary
  const label = slice.label
  const { width, height } = doc.image.dimensions
  return (
    <Root>
      <StyledLink
        fadeInLabel={label}
        isBiggerScreen={isBiggerScreen}
        to={linkResolver(doc.link._meta)}>
        <LazyImage
          placeholder={setPlaceholderImage(width, height)}
          src={doc.image.url}
          alt={doc.image.alt}
          width={width}
        />
        <RichText render={doc.text} />
      </StyledLink>
    </Root>
  )
}

const Root = styled.div`
    ${tw`cursor-pointer sm:mx-1 md:mx-4 lg:mx-8 mb-20`}
    position: relative;
`;

const StyledLink = styled(({ fadeInLabel, isBiggerScreen, ...rest }) => <Link {...rest} />)`
    & img {
        height: auto;
        width: 100%;
    }

     & h2 {
        ${tw`w-full absolute sm:text-vw m-auto text-white text-center tracking-wider`}
        font-size: 20vw;
        display: inline-block;
        opacity: ${({ fadeInLabel, isBiggerScreen }) => fadeInLabel === 'fade_in_text_on_hover' && isBiggerScreen ? '0' : '1'};
        transition: opacity .2s linear;
        font-family: 'Futura Medium';
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
    }

    & :hover h2 {
        opacity: 1;
    }
`;


export default ImageLink
